import React, { useState, useEffect, useMemo } from 'react'
import { useParams, Link } from "react-router-dom"
import axios from "axios"
import Pagination from '../pages/paginations'

const View = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(12) // Biasanya 12 biar pas (3 kolom x 4 baris atau 4x3)
    const [data, setData] = useState([])
    const [searchQuery, setSearchQuery] = useState('')

    useEffect(() => {
        getData('')
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async (keyword = '') => {
        try {
            const response = await axios.post("/api/promotion/publish", {
                jml: 120,
                key: keyword // 3. DIKIRIM SEBAGAI FIELD 'key' KE BACKEND
            })
            setData(response.data)
            setCurrentPage(1) // Reset ke halaman pertama setiap nyari data baru
        } catch (error) {
            console.error("Gagal mengambil data promosi:", error)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage])

    return (
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item">
                            <Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link>
                        </li>
                        <li className="breadcrumb-item active">PROMOSI PRODUK UMKM</li>
                    </ol>
                </nav>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <h1 className='color-dark font-bold lh-125'>PRODUK UMKM</h1>
                        <p className="lead color-dark">Telusuri produk umkm di Kota Bekasi</p>
                        <hr />

                        <div className="row mb-4">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Cari berdasarkan judul atau deskripsi..."
                                    value={searchQuery}
                                    onChange={(e) => {
                                        setSearchQuery(e.target.value) // Update state text
                                        getData(e.target.value)        // Langsung cari real-time
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            {tableData.length > 0 ? tableData.map((val, index) => (
                                <div className="col-md-3 mb-3" key={index}>
                                    <Link to={`/promosi/${val.code}/${val.title.replaceAll(' ', '-').replaceAll('/', '_').toLowerCase()}`} className="panel panel-dark panel-primary card-hover" style={{ textDecoration: 'none' }}>
                                        <div className="panel-heading">
                                            <h3 className='panel-title text-truncate' title={val.title}>{val.title.toUpperCase()}</h3>
                                        </div>
                                        <div className="panel-body no-p overflow-hidden">
                                            <img className='d-flex mr-3 media-object' style={{ width: '100%', height: '200px', objectFit: 'cover' }} src={(val.filePath && val.filePath !== '-') ? val.filePath : val.categoryPath} alt={val.title} />
                                        </div>
                                    </Link>
                                </div>
                            )) : (
                                <div className="col-md-12 text-center p-5">
                                    <h4 className="color-dark">Produk tidak ditemukan...</h4>
                                </div>
                            )}
                        </div>

                        {data.length > PageSize && (
                            <div className="text-center p-4">
                                <Pagination className="pagination-bar" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}

export default View